import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import heroMap from '../media/hero_map.png';
import { TwoKeyIcon } from './Icons';

const right2leftStyles = css`
  clip-path: polygon(0 0, 100% 0, 100% 8.3%, 0 11.9%);
  
  .hero-map {
    background: url(${heroMap}) no-repeat 0 -157%;
    background-size: 200%;
  }
`;

const left2rightStyles = css`
  clip-path: polygon(0 0, 100% 0, 100% 11.9%, 0 8.3%);
  
  .hero-map {
    background: url(${heroMap}) no-repeat 0 -86%;
    background-size: 160%;
  }
`;

const StyledDiv = styled.div`
  display: none;
  
  @media screen and (max-width: 575px) {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 840px;
    background: #17936f;
    
    .hero-map {
      position: relative;
      width: 50%;
      height: 100%;
      
      svg {
        position: absolute;
        top: 9px;
        right: 9px;
        height: 20px;
        fill: #fff;
      }
    }
    
    ${props => (props.reverse ? right2leftStyles : left2rightStyles)}
  }
`;

const PolygonHeader = ({ className, reverse }) => (
  <StyledDiv className={className} reverse={reverse}>
    <div className="hero-map">
      <TwoKeyIcon />
    </div>
  </StyledDiv>
);

PolygonHeader.propTypes = {
  reverse: PropTypes.bool,
  className: PropTypes.string,
};

PolygonHeader.defaultProps = {
  className: '',
};

export default PolygonHeader;
